export const testIds = {
  partnerScoreFilterContainer: 'ces-partner-score-filter-container',
  partnerScoreFilterYearQuarterDropdown: 'ces-partner-score-filter-year-quarter-dropdown',
  partnerScoreFilterSurveyLabel: 'ces-partner-score-filter-survey-title-label',
  partnerScoreFilterSurveyDropdown: 'ces-partner-score-filter-survey-title-dropdown',
};
